import React, { useEffect, useState, useRef } from 'react';
import { useSpring, animated } from 'react-spring';

interface ScrollingTextProps {
    children?: React.ReactNode;
    delay: number;
    pause: number;
    width?: string | number;
    style?: React.CSSProperties;
    className?: string;
    canAnimate?: boolean;
}

const ScrollingText: React.FC<ScrollingTextProps> = React.memo(
    ({ children, delay, pause, width, style, className, canAnimate = true }) => {
        const textRef = useRef<HTMLDivElement>(null);

        const [scrolling, setScrolling] = useState(false);
        const [scrollAmount, setScrollAmount] = useState(0);

        useEffect(() => {
            setScrollAmount(0);
            if (textRef.current) {
                // console.log('textRef', textRef);
                // console.log('offset', textRef.current.offsetWidth);
                // console.log('scroll', textRef.current.scrollWidth);
                const amount = textRef.current.scrollWidth - textRef.current.offsetWidth;
                if (amount > 0 && canAnimate) {
                    setScrollAmount(amount);
                }
            }
            return () => {
                setScrollAmount(0);
            };
        }, [textRef, children, width, style, className, canAnimate]);

        useEffect(() => {
            setScrolling(false);
            let id: NodeJS.Timeout;
            if (scrollAmount > 0) {
                setTimeout(() => {
                    setScrolling(true);
                }, delay);
                id = setInterval(() => {
                    setScrolling(false);
                    setTimeout(() => {
                        setScrolling(true);
                    }, delay);
                }, delay + pause + 15 * scrollAmount);
            }
            return () => {
                clearInterval(id);
                setScrolling(false);
            };
        }, [delay, pause, scrollAmount]);

        // useSpringフックを使用して、テキストのアニメーションを定義
        const scrollingAnimation = useSpring({
            from: { transform: 'translateX(0px)' },
            to: { transform: `translateX(-${scrollAmount}px)` },
            config: { duration: 15 * scrollAmount },
            reset: true,
        });

        return (
            <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', width: width ?? '100%' }} className={className}>
                <animated.div ref={textRef} style={scrolling ? scrollingAnimation : {}}>
                    <span style={style}> {children}</span>
                </animated.div>
            </div>
        );
    },
);

export default ScrollingText;
